module.exports = __webpack_public_path__ + "static/media/mohamadi.e5b05670.jpeg";